import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@/app/store';
import { resetClientScopedApiState } from '@/features/resetClientApiState';
import { useReleaseId } from '@/hooks/useReleaseId';
import { useDeliveryIdentifier } from '@/hooks/useDeliveryIdentifier';

export const useResetOnContextChange = () => {
  const releaseId = useReleaseId();
  const deliveryIdentifier = useDeliveryIdentifier();
  const key = `${releaseId ?? ''}|${deliveryIdentifier ?? ''}`;
  const dispatch = useDispatch<AppDispatch>();
  const previous = useRef(key);

  useEffect(() => {
    if (previous.current === key) return;
    previous.current = key;
    resetClientScopedApiState(dispatch);
  }, [key, dispatch]);
};
